module.exports = __webpack_public_path__ + "img/orderImageCheckout.6a3ebadb.png";